/* src/app/app.component.scss */
.fc-app {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 100px);
}
.bg-container {
  flex-grow: 1;
}
.enrollment-container {
  padding: 0 0 64px 0;
}
.container-title {
  text-align: left;
  width: 100%;
  padding-bottom: 12px;
  padding-top: 9px;
}
.container-title h1 {
  font-size: 3rem;
  color: #fff;
  text-shadow: 0px 2px 1px rgba(0, 0, 0, 0.24);
  -webkit-text-stroke-width: 0.5;
  -webkit-text-stroke-color: #fff;
  font-family:
    Lato,
    "Helvetica Neue",
    Helvetica,
    Arial,
    sans-serif;
  font-style: normal;
  font-weight: 300;
  line-height: 4.2rem;
  letter-spacing: -0.18rem;
}
@media (min-width: 768px) {
  .container-title h1 {
    font-size: 3.8rem;
    line-height: 7.2rem;
    letter-spacing: -0.24rem;
  }
}
@media (min-width: 992px) {
  .container-title h1 {
    font-size: 4.8rem;
    line-height: 7.2rem;
    letter-spacing: -0.29rem;
  }
}
@media (min-width: 1200px) {
  .container-title h1 {
    font-size: 5.2rem;
    line-height: 7.2rem;
    letter-spacing: -0.32rem;
  }
}
@media (min-width: 1400px) {
  .container-title h1 {
    font-size: 5.2rem;
    line-height: 7.2rem;
    letter-spacing: -0.32rem;
  }
}
@media (min-width: 768px) {
  .container-title {
    padding-bottom: 12px;
    padding-top: 9px;
  }
}
@media (min-width: 992px) {
  .container-title {
    padding-bottom: 12px;
    padding-top: 9px;
  }
}
@media (min-width: 1200px) {
  .container-title {
    padding-bottom: 20px;
    padding-top: 18px;
  }
}
@media (min-width: 1400px) {
  .container-title {
    padding-bottom: 20px;
    padding-top: 18px;
  }
}
.enrollment-form-tile {
  width: 100%;
  padding: 2.4rem;
  border-radius: 4px;
  background: var(--Background-bg-white, #fff);
  box-shadow: 2px 2px 2px 0px #cddce2;
}
@media (min-width: 768px) {
  .enrollment-form-tile {
    padding: 4.4rem;
  }
}
@media (min-width: 992px) {
  .enrollment-form-tile {
    padding: 4.4rem;
  }
}
@media (min-width: 1200px) {
  .enrollment-form-tile {
    padding: 4.4rem;
  }
}
@media (min-width: 1400px) {
  .enrollment-form-tile {
    padding: 4.4rem;
  }
}
/*# sourceMappingURL=app.component-4KVVKMGC.css.map */
